import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
} from '@mui/material';
// import '.../LicenseList.css'; // Import the CSS file
import '../License/LicenseList.css'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../axios/axios';
import moment from 'moment/moment';
import ResetButton from '../../Common_Components/ResetButton';
const style = {
    fontFamily: 'Times New Roman',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '18.4px',
    color: '#000000',
    alignItems: 'center'
}
const tableHeaderStyle = {
    fontFamily: 'Times New Roman',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '18.4px',
    color: '#302D2D'
}

const LicenseHistory = () => {
    const navigate = useNavigate();
    const { id } = useParams()
    const location = useLocation();

    // Access the passed object from state
    const { clientName } = location.state || {};
    const [licenses, setlicenses] = useState([])
    useEffect(() => {
        const getLicenselist = async () => {
            const response = await axiosInstance.get(`/licenses/history/${id}`)
            const { success, licenseHistory } = response.data
            if (success === true) {
                setlicenses(licenseHistory)
            } else {
                setlicenses([])
            }
        }
        if (id) {
            getLicenselist()
        }
    }, [id])
    const Handleback = () => {
        navigate('/client-management')
    }
    return (
        <div className="license-management">
            <TableContainer component={Paper}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: 2 }}>
                    <Typography sx={{
                        fontFamily: 'Times New Roman',
                        fontWeight: '700',
                        fontSize: '27px',
                        color: '#545454',
                        lineHeight: '23px',
                    }}>
                        {clientName}
                    </Typography>
                    <ResetButton label={'Back'} onClick={Handleback} />
                </Box>
                <Table>
                    <TableHead style={{ backgroundColor: '#EEDEFF' }}>
                        <TableRow>
                            <TableCell sx={tableHeaderStyle}>Sl no</TableCell>
                            <TableCell sx={tableHeaderStyle}>Product Name</TableCell>
                            <TableCell sx={tableHeaderStyle}>Product Version</TableCell>
                            <TableCell sx={tableHeaderStyle}>License Type</TableCell>
                            <TableCell sx={tableHeaderStyle}>User Count</TableCell>
                            <TableCell sx={tableHeaderStyle}>Expiry Date</TableCell>
                            <TableCell sx={tableHeaderStyle}>Issued Date</TableCell>
                            <TableCell sx={tableHeaderStyle}>License Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {licenses.map((license, index) => (
                            <TableRow key={license.slNo} style={{ backgroundColor: index % 2 === 0 ? '#F6F6F6' : '#DAD9D9' }}>
                                <TableCell sx={style}>{index + 1}</TableCell>
                                <TableCell sx={style}>{license.ProductName}</TableCell>
                                <TableCell sx={style}>{license.Version}</TableCell>
                                <TableCell sx={style}>{license.LicenseType}</TableCell>
                                <TableCell sx={style}>{license.UserLicenseCount}</TableCell>
                                <TableCell sx={style}>{moment(license.ExpiryDate).format('DD-MM-YYYY')}</TableCell>
                                <TableCell sx={style}>{moment(license.CreatedDate).format('DD-MM-YYYY')}</TableCell>
                                <TableCell sx={style}>{license.Status}</TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default LicenseHistory